export default "__VITE_ASSET__1c4d9a10__"